import React, { useRef, useEffect } from "react";

interface OtpField {
  name?: string;
  otpValues?: any;
  setOtpValues?: any;
  disabled: boolean
}
const OTPField = ({
  name,
  otpValues,
  setOtpValues,
  disabled
}: OtpField) => {

  const otpFieldsRef = useRef<any[]>([]);

  const handleInput = (index: number, value: any) => {
    if (value.length > 1) {
      return;
    }
    const newOtpValues = [...otpValues];
    newOtpValues[index] = value;

    const regex = /^[0-9]*[.,]?[0-9]*$/;

    if (!regex.test(newOtpValues[index].toString())) {
      return;
    } else {
      setOtpValues(newOtpValues);
    };
    if (value.length === 1 && index < otpValues.length - 1 && value !== '') {
      otpFieldsRef.current[index + 1].focus();
    }
  };

  const handleBackspace = (index: number) => {
    if (otpValues[index] !== "") {
      const newOtpValues = [...otpValues];
      newOtpValues[index] = "";
      setOtpValues(newOtpValues);
    } else if (index > 0) {
      otpFieldsRef.current[index - 1].focus();
    }
  };

  useEffect(() => {
    otpFieldsRef.current[0].focus();
  }, [])

  return (
    <div className="otp-container d-flex justify-content-center">
      {otpValues.map((value: any, index: number) => (
        <input
          key={index}
          type="text"
          maxLength={1}
          className="otp-input"
          name={name}
          disabled={disabled}
          value={value}
          inputMode="numeric"
          autoComplete="off"
          onChange={(e: any) => {
            handleInput(index, e.target.value);
          }}
          pattern="[0-9]*"
          onKeyDown={(e) => {
            if (e.key === "Backspace") {
              handleBackspace(index);
            }
          }}
          ref={(ref: any) => {
            otpFieldsRef.current[index] = ref;
          }}
        />
      )
      )}
    </div>
  );
};

export default OTPField;
